import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import contains from 'ramda/src/contains';
import Icon from '@components/@core/Icon';
import AppActions from '~/actions/app';

function Login() {
    const dispatch = useDispatch();
    const location = useLocation();

    const handleLogin = () => {
        const { pathname, search } = location;
        const route =
            contains('/community', pathname) || contains('/forums', pathname) || contains('/vendor-ratings', pathname) || contains('/in', pathname) || contains('company', search) ? pathname : null;
        dispatch(AppActions.modalRequest({ type: 'Authentication', data: { before: { route } } }));
    };

    return (
        <div className="d-flex cursor ms-3" onClick={handleLogin}>
            <Icon name="fas fa-right-to-bracket" color="white" size={20} />
            <span className="dsl-w14 ms-2">Login</span>
        </div>
    );
}

export default Login;
